/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import { TextInput, CheckBox } from "../../shared/Forms/";
import formWrapper from "../../shared/Form";
import ChangeHistory from "../../shared/ChangeHistory";

class TopicForm extends Component {
	render() {
		const { actionType, id } = this.props;
		return (
			<React.Fragment>
				{actionType === "update" && !!id && <ChangeHistory id={id} entity="topics" />}
				<TextInput field="name" id="name" placeholder="Name" autocomplete="off" />
				<TextInput field="description" id="description" placeholder="Description" autocomplete="off" />
				<CheckBox
					field="isHiddenInNotificationCenter"
					id="isHiddenInNotificationCenter"
					label="Hide in Notification Center"
				/>

				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					{this.props.buttonLabel}
				</div>
			</React.Fragment>
		);
	}
}

TopicForm.propTypes = {
	actionType: PropTypes.string,
	buttonLabel: PropTypes.string,
	id: PropTypes.string,
	submitForm: PropTypes.func,
	values: PropTypes.object,
};

export default formWrapper(TopicForm);
